import { useMemo } from 'react';
import { useQuery } from '@apollo/client/react';
import {
  GET_NOTIFICATION_COUNT,
  type GetNotificationCountData,
  type GetNotificationCountVariables,
} from '@jwp/ott-common/src/graphql/query/notification.queries';
import { getAuthApolloClient } from '@jwp/ott-common/src/graphql/ApolloClient';
import { UNREAD_NOTIFICATION_COUNT_FILTER } from '@jwp/ott-common/src/constants/notifications';
import { useAccountStore } from '@jwp/ott-common/src/stores/AccountStore';
import { GetCookie } from '@jwp/ott-common/src/utils/cookie';

type Options = {
  skip?: boolean;
};

/** Bell badge — getNotificationCount(nIsRead: true) only; no getAllNotifications on home. */
export default function useNotificationCount({ skip = false }: Options = {}) {
  const user = useAccountStore((s) => s.user);
  const accountLoading = useAccountStore((s) => s.loading);
  const accessToken = GetCookie('AccessToken');
  const isEnabled = !skip && !!user && !accountLoading && !!accessToken;

  const client = useMemo(() => getAuthApolloClient(), []);

  const { data, refetch } = useQuery<GetNotificationCountData, GetNotificationCountVariables>(GET_NOTIFICATION_COUNT, {
    client,
    variables: { nIsRead: UNREAD_NOTIFICATION_COUNT_FILTER },
    skip: !isEnabled,
    fetchPolicy: 'cache-and-network',
    errorPolicy: 'all',
  });

  const unreadCount = data?.getNotificationCount ?? 0;
  const hasUnread = unreadCount > 0;

  return { hasUnread, unreadCount, refetch };
}
